/* eslint-disable camelcase */
import { colors } from '@lmc/common/constants'
import type { CbSubscription } from '@lmc/common/types'
import { EmptyState, Text } from '@lmc/ui-kit'
import SubscriptionTableRow from '../SubscriptionTableRow'

type SubscriptionTableProps = {
  subscriptions: Array<CbSubscription>
}

const headerLabels = ['Subscription', 'Status', 'Price', 'Billing Date']

export const SubscriptionTable = ({
  subscriptions
}: SubscriptionTableProps) => (
  <div style={styles.container}>
    <div style={styles.tableHeaderContainer}>
      {headerLabels.map((label) => (
        <div style={styles.labelConatainer} key={label}>
          <Text color="darkgrey" style={styles.label}>
            {label}
          </Text>
        </div>
      ))}
    </div>
    {subscriptions.length ? (
      subscriptions.map((sub) => (
        <SubscriptionTableRow
          sub={sub}
          key={sub?.subscription_items?.[0]?.item_price_id || sub?.plan_id}
        />
      ))
    ) : (
      <div style={styles.emptyState}>
        <EmptyState title="Nothing to see here">
          <Text color="darkgrey" style={styles.label}>
            You are on the free plan
          </Text>
        </EmptyState>
      </div>
    )}
  </div>
)

const styles = {
  container: { marginTop: 24 },
  tableHeaderContainer: {
    color: colors.darkgrey,
    textAlign: 'center' as const,
    padding: '32px 0 0 0',
    fontSize: 12,
    display: 'flex',
    margin: 12,
    alignItems: 'center'
  },
  labelConatainer: {
    flex: 1
  },
  label: { fontWeight: 'bold' },
  // TODO: This is not a good solution. The empty state component needs to be looked at
  // In it's current form, it won't align with the designs
  emptyState: { opacity: 0.4 }
}

export default SubscriptionTable
